import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import PageShell from "@/components/PageShell";
import { trackEmailClick } from "@/lib/analytics";

const Terms = () => {
  return (
    <PageShell
      title="Terms of Service | Skandor Technologies"
      description="Terms and conditions governing your use of Skandor Technologies services."
      canonicalPath="/terms"
    >
      <section className="pb-16">
        <div className="container mx-auto max-w-3xl">
          <Link
            to="/"
            className="inline-flex items-center gap-2 min-h-11 text-sm text-muted-foreground hover:text-ink transition-colors mb-8"
          >
            <ArrowLeft className="w-4 h-4" />
            Back to Home
          </Link>

          <h1 className="text-[clamp(2rem,5vw,3.25rem)] font-semibold text-ink mb-8">Terms of Service</h1>

          <div className="max-w-none text-muted-foreground space-y-8">
            <p className="text-lg">
              <strong className="text-ink">Last updated:</strong> February 1, 2026
            </p>

            <section className="space-y-3">
              <h2 className="text-xl font-semibold text-ink">1. Agreement to terms</h2>
              <p className="text-base">
                By accessing or using the Skandor Technologies website and services, you agree to be
                bound by these Terms of Service. If you disagree with any part of these terms, you
                may not access our services.
              </p>
            </section>

            <section className="space-y-3">
              <h2 className="text-xl font-semibold text-ink">2. Description of services</h2>
              <p className="text-base">
                Skandor Technologies provides senior-led advisory and delivery across strategy
                &amp; transformation, AI &amp; product, go-to-market, and operations &amp;
                resilience — including ERP, planning and supply-chain work where relevant to the
                engagement.
              </p>
            </section>

            <section className="space-y-3">
              <h2 className="text-xl font-semibold text-ink">3. Intellectual property</h2>
              <p className="text-base">
                All content, features, and functionality on our website, including text, graphics,
                logos, and software, are the exclusive property of Skandor Technologies and are
                protected by international copyright, trademark, and other intellectual property
                laws.
              </p>
            </section>

            <section className="space-y-3">
              <h2 className="text-xl font-semibold text-ink">4. User responsibilities</h2>
              <ul className="list-disc pl-6 space-y-2 text-base">
                <li>Provide accurate and complete information when submitting inquiries</li>
                <li>Use our services only for lawful purposes</li>
                <li>Not attempt to interfere with the proper functioning of our website</li>
                <li>Maintain the confidentiality of any proprietary information shared during engagements</li>
              </ul>
            </section>

            <section className="space-y-3">
              <h2 className="text-xl font-semibold text-ink">5. Confidentiality</h2>
              <p className="text-base">
                Any information you share with us during consultations or through our contact forms
                will be treated as confidential and will not be disclosed to third parties without
                your consent, except as required by law.
              </p>
            </section>

            <section className="space-y-3">
              <h2 className="text-xl font-semibold text-ink">6. Limitation of liability</h2>
              <p className="text-base">
                Skandor Technologies shall not be liable for any indirect, incidental, special,
                consequential, or punitive damages resulting from your use of our services. Our
                total liability shall not exceed the amount paid by you for the specific services
                giving rise to the claim.
              </p>
            </section>

            <section className="space-y-3">
              <h2 className="text-xl font-semibold text-ink">7. Disclaimer</h2>
              <p className="text-base">
                Our services are provided "as is" without warranties of any kind. While we strive
                to provide accurate and helpful guidance, we make no guarantees regarding specific
                business outcomes or results from our consulting services.
              </p>
            </section>

            <section className="space-y-3">
              <h2 className="text-xl font-semibold text-ink">8. Governing law</h2>
              <p className="text-base">
                These Terms shall be governed by and construed in accordance with applicable laws,
                without regard to conflict of law principles.
              </p>
            </section>

            <section className="space-y-3">
              <h2 className="text-xl font-semibold text-ink">9. Changes to terms</h2>
              <p className="text-base">
                We reserve the right to modify these Terms at any time. Continued use of our
                services after changes constitutes acceptance of the new terms.
              </p>
            </section>

            <section className="space-y-3">
              <h2 className="text-xl font-semibold text-ink">10. Contact us</h2>
              <p className="text-base">
                Questions? Email{" "}
                <a href="mailto:Admin@skandortech.ai" onClick={() => trackEmailClick("terms_page")} className="text-steel-2 font-semibold hover:underline underline-offset-4">
                  Admin@skandortech.ai
                </a>.
              </p>
            </section>
          </div>
        </div>
      </section>
    </PageShell>
  );
};

export default Terms;
